"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetEnquiryDetailsApiResponseDto = instanceOfGetEnquiryDetailsApiResponseDto;
exports.GetEnquiryDetailsApiResponseDtoFromJSON = GetEnquiryDetailsApiResponseDtoFromJSON;
exports.GetEnquiryDetailsApiResponseDtoFromJSONTyped = GetEnquiryDetailsApiResponseDtoFromJSONTyped;
exports.GetEnquiryDetailsApiResponseDtoToJSON = GetEnquiryDetailsApiResponseDtoToJSON;
exports.GetEnquiryDetailsApiResponseDtoToJSONTyped = GetEnquiryDetailsApiResponseDtoToJSONTyped;
var GetEnquiryDetailsResponseDto_1 = require("./GetEnquiryDetailsResponseDto");
/**
 * Check if a given object implements the GetEnquiryDetailsApiResponseDto interface.
 */
function instanceOfGetEnquiryDetailsApiResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function GetEnquiryDetailsApiResponseDtoFromJSON(json) {
    return GetEnquiryDetailsApiResponseDtoFromJSONTyped(json, false);
}
function GetEnquiryDetailsApiResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, GetEnquiryDetailsResponseDto_1.GetEnquiryDetailsResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function GetEnquiryDetailsApiResponseDtoToJSON(json) {
    return GetEnquiryDetailsApiResponseDtoToJSONTyped(json, false);
}
function GetEnquiryDetailsApiResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, GetEnquiryDetailsResponseDto_1.GetEnquiryDetailsResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
